module.exports = __webpack_public_path__ + "static/media/github.b0c35835.svg";